<template>
  <div class="flex flex-col items-center">
    <TourClassicNavigation />

    <div class="w-full max-w-4xl mx-auto flex flex-col gap-2 px-2 mt-2">
      <slot />
    </div>

    <Footer />
  </div>
</template>
